import * as THREE from "three";

export class PlanOrigin {
    id: string;

    name: string;

    color: string;

    position: THREE.Vector3;

    direction: THREE.Vector2;

    isActive: boolean;

    relativeOrigineId?: string;

    constructor() {
        this.id = crypto.randomUUID();
        this.name = "Origine par défaut";
        this.color = "#00c951";
        this.position = new THREE.Vector3(0, 0, 0);
        this.direction = new THREE.Vector2(1, 0);
        this.isActive = false;
    }

    clone() {
        const origin = new PlanOrigin();
        origin.id = this.id;
        origin.name = this.name;
        origin.color = this.color;
        origin.isActive = this.isActive;
        origin.relativeOrigineId = this.relativeOrigineId;
        origin.position = this.position.clone();
        origin.direction = this.direction.clone();
        return origin;
    }

    public static getDefault() : PlanOrigin {
        return new PlanOrigin();
    }

    public setId(id: string) {
        this.id = id;
    }

    public setName(name: string) {
        this.name = name;
    }

    public setColor(color: string) {
        this.color = color;
    }

    public setPosition(position: THREE.Vector3) {
        this.position = position;
    }

    public setDirection(direction: THREE.Vector2) {
        this.direction = direction;
    }

    public setIsActive(isActive: boolean) {
        this.isActive = isActive;
    }

    public setRelativeId(relativeId?: string) {
        this.relativeOrigineId = relativeId;
    }

    public setPositionFromJSON(position: Record<string, unknown>) {
        const x = (position.x ?? position.X) as number ?? 0;
        const y = (position.y ?? position.Y) as number ?? 0;
        const z = (position.z ?? position.Z) as number ?? 0;
        this.position = new THREE.Vector3(x, y, z);
    }

    public setDirectionFromJSON(direction: Record<string, unknown>) {
        const x = (direction.x ?? direction.X) as number ?? 0;
        const y = (direction.y ?? direction.Y) as number ?? 0;
        this.direction = new THREE.Vector2(x, y);
    }
    
    public static fromJSON(data: Record<string, unknown>) {
        if (data && typeof data === 'object') {
            const posData = (data.position ?? data.Position) as Record<string, number>;
            const dirData = (data.direction ?? data.Direction) as Record<string, number>;

            const origin = new PlanOrigin();
            origin.setPosition(new THREE.Vector3((posData?.x ?? posData.X) ?? 0, (posData?.y ?? posData.Y) ?? 0, (posData?.z ?? posData.Z) ?? 0));
            origin.setDirection(new THREE.Vector2((dirData?.x ?? dirData.X) ?? 0, (dirData?.y ?? dirData.Y) ?? 0));
            return origin;
        } 
        
        return PlanOrigin.getDefault();
    }
}

export default PlanOrigin;